import React from 'react';
import { Modal, Banner } from '@/components/AdminPanel/AdminPrimitives';
import { LCBtn } from '@/components/common/LCPrimitives';

interface ConfirmationDialogProps {
  open: boolean;
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  severity?: 'warning' | 'error' | 'info';
  onConfirm: () => void;
  onCancel: () => void;
}

const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
  open, title, message,
  confirmLabel = 'Confirm', cancelLabel = 'Cancel',
  severity = 'warning', onConfirm, onCancel,
}) => (
  <Modal
    open={open}
    onClose={onCancel}
    title={title}
    size="sm"
    footer={
      <>
        <LCBtn variant="outline" size="sm" onClick={onCancel}>{cancelLabel}</LCBtn>
        <LCBtn variant="primary" size="sm" onClick={onConfirm}>{confirmLabel}</LCBtn>
      </>
    }
  >
    <Banner
      variant={severity === 'error' ? 'error' : severity === 'warning' ? 'warn' : 'info'}
      className="mb-3"
    >
      {message}
    </Banner>
    <p className="text-[13px] text-[#555] m-0">
      This action cannot be undone. Are you sure you want to continue?
    </p>
  </Modal>
);

export default ConfirmationDialog;
